import Slider from "react-slick";
import { Container } from "reactstrap";
import AddressCard from "../../../components/DisplayMyAccount/AddressCard";

const ManageAddressSliderView = ( {addressList, onUpdateAddress } ) =>{
  const listLength = addressList?.length;
  
    const settings = {
        className: "manage-address-slider",
        infinite: false,
        centerPadding: "20px",
        speed: 500,
        dots: true,
        accessibility: true,
        slidesToShow: (listLength === 1) ? 1 : 3,
        slidesToScroll: (listLength === 1) ? 1 : 2,
        centerMode: false,
        lazyLoad: true,
        responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
    };
    return(
        <Container>
            <Slider {...settings} >
                { addressList?.map( (address, index) => (
                    <AddressCard
                    cname="slider-card"
                    key={index}
                    address={address}
                    index={index}
                    addressType='SHIPPING'
                    updateAddress={onUpdateAddress}
                    listLength = {listLength}
                />
                ) ) }
            </Slider>
        </Container>
    )
}

export default ManageAddressSliderView;